export const JobCreateRoute = [
    {
        "url": "/job/create/{job_id:[0-9]*}?template&jobBrandId&brandType&atrId&positionCode&duplicate&source",
        "enableUTM": true,
        "name": "appLayout.harriSH.job_create",
        "type": "frontend",
        "component": 'jobCreateContainer',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["job_create"]
        },
        "route_dependencies": []
    }
];
//# sourceMappingURL=job-create.routes.js.map